module.exports = __webpack_public_path__ + "img/panturrilha-e.c1d59f4a.png";